import { render, staticRenderFns } from "./ServiceComparisonsTable.vue?vue&type=template&id=2502813c&scoped=true&"
import script from "./ServiceComparisonsTable.vue?vue&type=script&lang=js&"
export * from "./ServiceComparisonsTable.vue?vue&type=script&lang=js&"
import style0 from "./ServiceComparisonsTable.vue?vue&type=style&index=0&id=2502813c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2502813c",
  null
  
)

export default component.exports